import { LoginCallback } from '@okta/okta-react';
import React from 'react';
import { useHistory } from 'react-router-dom';

const OktaLoginCallback: React.FC = () => {
  const history = useHistory();

  return <LoginCallback onAuthResume={() => history.push('/')} />;
};

export default OktaLoginCallback;
